import { SecondaryButton, TextButton } from '../components/Button';
import { Card } from '../components/Card';
import { Screen } from '../components/Screen';
import { ToggleCard } from '../components/ToggleCard';
import { copy } from '../copy';
import { selectQueueCount, useAppStore } from '../state/store';

const APP_VERSION = '0.1.0';

/** J4 — Instellingen. Geen thema-instelling (B1), geen eigen pincode (B13). */
export function SettingsScreen() {
  const session = useAppStore((s) => s.session);
  const prefs = useAppStore((s) => s.prefs);
  const setPrefs = useAppStore((s) => s.setPrefs);
  const navigate = useAppStore((s) => s.navigate);
  const openSheet = useAppStore((s) => s.openSheet);
  const queueCount = useAppStore(selectQueueCount);

  return (
    <Screen
      name="settings"
      foot={
        <SecondaryButton onClick={() => openSheet('logout')}>{copy.settings.logout}</SecondaryButton>
      }
    >
      <div className="row row--between pad-x" style={{ paddingTop: 14 }}>
        <h1 className="t-serif t-titel">{copy.settings.title}</h1>
        <TextButton onClick={() => navigate('day')}>{copy.settings.close}</TextButton>
      </div>

      <div className="stack pad-x" style={{ paddingTop: 16 }}>
        <Card>
          <div style={{ fontSize: 17, fontWeight: 600 }}>{session?.driverName ?? ''}</div>
          <div className="o-65" style={{ fontSize: 16, marginTop: 2 }}>
            {session?.email ?? ''}
          </div>
        </Card>

        <ToggleCard
          title={copy.settings.sound}
          checked={prefs.soundEnabled}
          onChange={(next) => void setPrefs({ soundEnabled: next })}
        />

        <p className="t-caption o-55" style={{ margin: 0 }}>
          {copy.settings.version(APP_VERSION)}
          {queueCount > 0 ? ` · ${copy.status.queue(queueCount)}` : ''}
        </p>
      </div>
    </Screen>
  );
}
